import { Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DiscussionService } from '../../../../shared-service/services/discussion.service';

@Component({
  selector: 'app-create-comment',
  templateUrl: './create-comment.component.html',
  styleUrls: ['./create-comment.component.css']
})
export class CreateCommentComponent implements OnInit {

  @Input()
  forumId:any;
  @Input()
  commentId:any;
  @Input()
  parentCommentId:any;
  @Input()
  commentType:any;
  @Input()
  isParent=false;

  @Output()
  commentSaved = new EventEmitter();

  imageSrc: string;


  fileName: string;
  fileToUpload: File = null;
  comment_form: FormGroup;
  hideAttachment = true;
  userId='';
  userData:any;
  supportText = 'Uploaded image format is not supported, please upload png/jpg/jpeg format images';
  showSupportText = false;

  constructor(public discussionService: DiscussionService,
    private _formBuilder: FormBuilder ) { }

  ngOnInit() {
    if (localStorage.getItem('userData')){
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userId = this.userData.user_id;
    }
    this.comment_form = this._formBuilder.group({'comment': ['', Validators.required]});
  }

  markFormTouched(group: FormGroup | FormArray) {
    Object.keys(group.controls).forEach((key: string) => {
      const control = group.controls[key];
      if (control instanceof FormGroup || control instanceof FormArray) { control.markAsTouched(); this.markFormTouched(control); }
      else { control.markAsTouched(); };
    });
  };

  addComment() {
    this.markFormTouched(this.comment_form);
    if(this.comment_form && this.comment_form.valid) {
      const formData = new FormData();
      formData.append('user_id', this.userId);
      formData.append('comment_description', this.comment_form.value.comment);
      formData.append('comment_type', this.commentType);
      formData.append('comment_parent_id', this.parentCommentId);
      formData.append('comment_mcq_answers', '');
      formData.append('forum_id', this.forumId);
      formData.append('forum_file', this.fileToUpload);

      this.discussionService.addComment(formData).subscribe((res:any) => {
        if(res && res.data) {
         // this.comment_form.get('comment').setValue('');
         this.comment_form.reset();
          this.commentSaved.emit(res.data);
          this.discussionService.answerCountRefresh.next(true);
        }
      });
    }
  }

  fileChangeEventUpload(files: FileList){
    const allowed_types = ['image/png','image/jpg','image/jpeg'];
    let fileType =  files.item(0).type;
    if(allowed_types.includes(fileType)) {
      this.showSupportText = false;
      this.fileToUpload = files.item(0);
      this.fileName = this.fileToUpload.name;
      this.setpreviewImage();
    } else {
      this.showSupportText = true;
    }
  }

  setpreviewImage() {
    const reader = new FileReader();
    reader.readAsDataURL(this.fileToUpload);
    reader.onload = () => {
      this.imageSrc = reader.result as string;
    };
  }
  removeFile() {
    this.fileName = '';
  }


}
